import { render, staticRenderFns } from "./NoticePage.vue?vue&type=template&id=53f93f02&scoped=true&"
import script from "./NoticePage.vue?vue&type=script&lang=js&"
export * from "./NoticePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f93f02",
  null
  
)

export default component.exports